import Compact from "antd/es/space/Compact";
import { apiGeoTag } from "./AxiosInstance";

export const GetGeoTagEmployeesApi = async (
  page,
  isActive,
  employeeId,
  employeeName,
  isGeoTag
) =>
  apiGeoTag.get(
    `/admin/employee/?page_num=${page}&page_size=10&is_active=${isActive}&employee_id=${employeeId}&name=${employeeName}&is_geotag=${isGeoTag}`
  );

export const DeleteGeoTagEmployeeApi = async (id) =>
  apiGeoTag.delete(`/admin/employee/${id}`);

export const AddGeoTagEmployeeApi = async (val, geotagEnable) =>
  apiGeoTag.post("/admin/employee/", {
    name: val.name,
    employee_id: val.employeeId,
    biometric_id: val.biometricId,
    // dob: val.dob,
    email: val.email,
    company: val.company,
    // is_geotag: geotagEnable,
    // date_of_joining: {
    //   start_date: val.doj,
    //   end_date: "9999-12-31",
    // },
    // personal_email: val.personalEmail,
    // mobile: val.personalMobile,
    // designation: val.designation,
    // department: val.department,
    // location: val.location,
    manager: {
      name: val.managerName,
      email: val.managerEmail,
      employee_id: val.managerId,
    },
  });
export const UpdateGeoTagEmployeeApi = async (id, val, geotagEnable) =>
  apiGeoTag.post(`/admin/employee/${id}`, {
    name: val.name,
    employee_id: val.employeeId,
    biometric_id: val.biometricId,
    company: val.company,

    // dob: val.dob,
    // is_geotag: geotagEnable,
    // date_of_joining: {
    //   start_date: val.doj,
    //   end_date: val.doe ? val.doe : "9999-12-31",
    // },
    // personal_email: val.personalEmail,
    // mobile: val.personalMobile,
    // designation: val.designation,
    // department: val.department,
    // location: val.location,
    manager: {
      name: val.managerName,
      email: val.managerEmail,
      employee_id: val.managerId,
    },
    email: val.officialemail,
    // asset_type: val.system,
    // operating_system: val.os,
    // email_groups: val.email_group,
    // photocopy_access: val.photocopyMachineAccess,
    // msoffice_access: val.msOfficeAccess,
    // cisco_vpn: val.CiscoVpn,
    // ssl_vpn: val.SSlVpn,
    // sap_account: val.sapAccess,
    // access_card: val.accessCard,
    // any_specific_software: val.anySpfSoft,
  });

export const AssetRequisitionApi = async (id, val) =>
  apiGeoTag.put(`/admin/employee/${id}`, {
    official_email: val.officialEmail,
    asset_type: val.system,
    operating_system: val.os,
    email_groups: val.email_group,
    photocopy_access: val.photocopyMachineAccess,
    msoffice_access: val.msOfficeAccess,
    cisco_vpn: val.CiscoVpn,
    ssl_vpn: val.SSlVpn,
    sap_account: val.sapAccess,
    access_card: val.accessCard,
    any_specific_software: val.anySpfSoft,
  });

export const GeoTagExcelUploadApi = async (formData) =>
  apiGeoTag.post("/admin/employee/excel", formData, {
    headers: {
      "Content-type": "multipart/form-data",
    },
  });

export const GetReportApi = async (page, employeeId, date, isExport) =>
  apiGeoTag.get(
    `/admin/report/attendance?page_num=${page}&page_size=10&employee_id=${employeeId}&start_date=${date[0]}&end_date=${date[1]}&export=${isExport}`
  );
